/*
 * PanamaJack — "Leer más / leer menos" en descripciones (colección y página).
 * Extraído de theme.js durante el rebase a Showcase 10.2.0 (iso-funcional).
 * Dos variantes: estándar (.leer_mas / .ocultar_mas, alturas auto/160px) y
 * "bm" (.leer_mas_bm / .ocultar_mas_bm, alturas auto/170px).
 * Requiere jQuery (theme.jQuery, con fallback a jQuery global).
 */
(function () {
  var $ = (window.theme && window.theme.jQuery) || window.jQuery;
  if (!$) return;

  $(function () {
    $(".leer_mas").click(function () {
      $(".mostrar-leer-mas").addClass("hidden");
      $(".ocultar-leer-mas").removeClass("hidden");
      $(".ocultar_leermas").css("height", "auto");
    });

    $(".ocultar_mas").click(function () {
      $(".ocultar-leer-mas").addClass("hidden");
      $(".mostrar-leer-mas").removeClass("hidden");
      $(".ocultar_leermas").css("height", "160px");
    });

    $(".leer_mas_bm").click(function () {
      $(".mostrar-leer-mas_bm").addClass("hidden");
      $(".ocultar-leer-mas_bm").removeClass("hidden");
      $(".ocultar_leermas_bm").css("height", "auto");
    });

    $(".ocultar_mas_bm").click(function () {
      $(".ocultar-leer-mas_bm").addClass("hidden");
      $(".mostrar-leer-mas_bm").removeClass("hidden");
      $(".ocultar_leermas_bm").css("height", "170px");
    });
  });
})();
